import LoginForm from "@/components/login-form";
import { useAuth } from "@/global-hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";

export default function LoginPage() {
	const auth = useAuth();
	const location = useLocation();

	if (!auth.isPending && auth.isAuthenticated) {
		// Redirect to the page they tried to visit, or dashboard as fallback
		const from =
			location.state?.from?.pathname || auth.user?.role === "manager"
				? "/statistics"
				: "/dashboard";
		return <Navigate to={from} replace />;
	}

	return (
		<div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-blue-950 dark:to-indigo-900 flex items-center justify-center p-4">
			<LoginForm />
		</div>
	);
}
